import { Component, OnInit, Input } from '@angular/core';



const noop = () => {
};


@Component({
  selector: 'adahi-modal',
  templateUrl: './modal.component.html',

})
export class ModalComponent implements OnInit {
  ngOnInit(): void {
  }
  //The internal data model
 

  @Input() title: string;

  @Input() body: string;








}